export { default as Truncate } from './Truncate';
export * from './useTruncatedText';
export * from './useTruncateStyleProps';
